<template>
  <div class="out">
    <div class="left">
      <div>
        <span v-text="weather.temperature || '--'"></span>
        <span class="unit">℃</span>
      </div>
      <div><span>室外温度</span></div>
    </div>
    <div class="right">
      <div>
        <img :src="icon" style="width: 45px" />
      </div>
      <div><span v-text="weather.desc || '--'"></span></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import comm from "../assets/lib/comm";
import basic from "../model/zone";

export default {
  name: "OutWeather",
  computed: {
    ...mapState(["weather", "zone"]),
    // icon () {
    //   return comm.getIcon(this.weather.cond_code)
    // }
    // 新版天气接口没有code，所以使用中文匹配
    icon() {
      return comm.getIconZh(this.weather.desc);
    },
  },
  mounted() {
    this.interval = comm.timerInClock(this.refresh, 10, 60);
  },
  methods: {
    async refresh() {
      let w = await basic.getWeatherByZone(this.zone.id);
      if (w.data && w.data["HeWeather5"] && w.data["HeWeather5"].length) {
        window.vm.$store.commit("SET_WEATHER", w.data["HeWeather5"][0].now);
      }
    },
  },
  beforeDestroy() {
    this.interval && clearInterval(this.interval);
  },
};
</script>

<style scoped lang="less">
@import "../assets/less/base";

.out {
  padding: 20px;
  color: @base-white;
  display: flex;
  justify-content: space-between;
  > .left {
    .text-center;
    > div:first-child {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      margin-top: -6px;
      margin-bottom: -8px;
      > span:first-child {
        font-size: 36px;
        font-weight: 600;
      }
      > span:last-child {
        font-size: 18px;
      }
    }
    > div:last-child {
      font-size: 14px;
    }
  }
  > .right {
    .text-center;
    > div:first-child {
      margin-top: -6px;
      height: 34px;
    }
    > div:last-child {
      margin-top: 10px;
      font-size: 12px;
    }
  }
}
</style>
